import { Toggle, TooltipV2 } from '@cimplico/components';
import { Description } from './Configurations';

type ToggleFieldProps = {
    title: string;
    description: string;
    defaultEnabled: boolean;
    disabledHint?: string;
    onToggle: () => void;
};

function ToggleField({ title, description, defaultEnabled, disabledHint, onToggle }: ToggleFieldProps): JSX.Element {
    return (
        <div className="flex gap-2">
            <Description title={title} description={description} />
            <div className="mt-4">
                <TooltipV2 message={disabledHint} disabled={!disabledHint}>
                    <Toggle type="short" onToggle={onToggle} defaultEnabled={defaultEnabled} isDisabled={disabledHint !== undefined} />
                </TooltipV2>
            </div>
        </div>
    );
}

export default ToggleField;
